import type { DisciplineMessageSender, DisciplinePaymentOption } from '../../enums'
import type { DisciplinePaymentLink } from '../../interfaces'
import type { DisciplinePaymentLinksStore } from './interfaces'

import { createDisciplinePaymentLinksState } from './state'

export const actions = {
  setLoading (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['loading']): void {
    this.loading = payload
  },
  setProducts (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['products']): void {
    this.products = payload
  },
  setPaymentOption (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['paymentOption']): void {
    this.paymentOption = payload
  },
  setAutoRenew (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['autoRenew']): void {
    this.autoRenew = payload
  },
  setPackageId (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['packageId']): void {
    this.packageId = payload
  },
  setInstallmentId (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['installmentId']): void {
    this.installmentId = payload
  },
  setDiscount (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['discount']): void {
    this.discount = payload
  },
  setExpiresAt (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['expiresAt']): void {
    this.expiresAt = payload
  },
  setCalculating (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['calculating']): void {
    this.calculating = payload
  },
  setCalculationError (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['calculationError']): void {
    this.calculationError = payload
  },
  setOrderCalculation (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['orderCalculation']): void {
    this.orderCalculation = payload
  },
  setSubscriptionCalculation (
    this: DisciplinePaymentLinksStore,
    payload: DisciplinePaymentLinksStore['subscriptionCalculation'],
  ): void {
    this.subscriptionCalculation = payload
  },
  setGenerating (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['generating']): void {
    this.generating = payload
  },
  setLink (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLink): void {
    this.links = [...this.links.filter(link => link.option !== payload.option), payload]
  },
  dropLinks (this: DisciplinePaymentLinksStore, options: DisciplinePaymentOption[]): void {
    this.links = this.links.filter(link => !options.includes(link.option))
  },
  setLinksTab (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['linksTab']): void {
    this.linksTab = payload
  },
  setSender (this: DisciplinePaymentLinksStore, sender: DisciplineMessageSender, checked: boolean): void {
    const others = this.senders.filter(item => item !== sender)
    this.senders = checked ? [...others, sender] : others
  },
  setSending (this: DisciplinePaymentLinksStore, payload: DisciplinePaymentLinksStore['sending']): void {
    this.sending = payload
  },
  reset (this: DisciplinePaymentLinksStore): void {
    Object.assign(this, createDisciplinePaymentLinksState())
  },
}
